import { createContext } from 'react';

import { USER_ROLES } from '@features/auth/utils/constants.ts';
import { UserCountryCode } from '@shared/types/countryCodes.ts';
import { UserId } from '@shared/types/users.ts';

type PossibleUserRoles = keyof typeof USER_ROLES;

export interface UserDetails {
  role: PossibleUserRoles;
  id: UserId;
  countryCode: UserCountryCode | null;
  isExternalDirectClient: boolean;
  isExternalAgency: boolean;
  isAnyExternalUser: boolean;
  isPortfolioSalesUser: boolean;
  isSuperAdminUser: boolean;
  isSalesAdminUser: boolean;
  isItalianUser: boolean;
  isSpanishUser: boolean;
  isGermanUser: boolean;
}

export const UserDetailsContext = createContext<UserDetails | undefined>(undefined);
